import { useTranslation } from 'react-i18next';
import Spinner from '../spinner/Spinner';

interface DeleteButtonProps {
  loading?: boolean;
  onClick: () => void;
}

export default function DeleteButton({ loading, onClick }: DeleteButtonProps): JSX.Element | null {
  const { t } = useTranslation();

  return (
    <button className="btn btn-danger btn-sm mx-1" type="button" onClick={onClick}>
      {loading ? <Spinner /> : <span>{t('Views.DeleteButton')}</span>}
    </button>
  );
}
